import firebase from 'firebase';
import { setBaseUrl } from '@/helpers/http';

if (location.hostname.toLowerCase() === 'jsk.matt.tk') {
    firebase.initializeApp({
        apiKey: 'AIzaSyC9NmQiDvok32rFwaRo9be3lcZVbiMAOig',
        authDomain: 'jskrc-6d11c.firebaseapp.com',
        databaseURL: 'https://jskrc-6d11c.firebaseio.com',
        projectId: 'jskrc-6d11c',
        storageBucket: 'jskrc-6d11c.appspot.com',
        messagingSenderId: '992181013593',
    });
    setBaseUrl('https://europe-west1-jskrc-6d11c.cloudfunctions.net/api');

} else {
    firebase.initializeApp({
        apiKey: 'AIzaSyCVK3lxfsjBD4GuCEDqPSyeqcErLv1XJNc',
        databaseURL: 'https://eurdev-fbd23.firebaseio.com',
        storageBucket: 'eurdev-fbd23.appspot.com',
        authDomain: 'eurdev-fbd23.firebaseapp.com',
        messagingSenderId: '1055703737659',
        projectId: 'eurdev-fbd23',
    });
    if (location.hostname.toLowerCase() === 'localhost') {
        setBaseUrl('http://localhost:5000/eurdev-fbd23/us-central1/api');
    } else {
        setBaseUrl('https://europe-west1-eurdev-fbd23.cloudfunctions.net/api');
    }
}



// firebase utils
const db = firebase.firestore();
const auth = firebase.auth();
// const currentUser = auth.currentUser;
const fsNS = firebase.firestore;
const funcs = firebase.app().functions('europe-west1');

db.settings({
    timestampsInSnapshots: true,
});

// firebase collections
const colEvents = db.collection('events');
const colResults = db.collection('results');
const colMembers = db.collection('members');

export default {
    db,
    auth,
    firebase,
    colEvents,
    colResults,
    colMembers,
    fsNS,
    funcs,
};
